import { VoucherFormat } from '../utils/voucher.js';
export const VOUCHER_PREFIXES = {
    JV: {
        prefix: 'JV',
        format: VoucherFormat.MonthlyReset,
        reset: 'MONTHLY',
        pad: 6,
        description: 'Journal Voucher',
    },
    PV: {
        prefix: 'PV',
        format: VoucherFormat.YearlyResetYYMM,
        reset: 'YEARLY',
        pad: 6,
        description: 'Payment Voucher',
    },
    RV: {
        prefix: 'RV',
        format: VoucherFormat.YearlyResetYYMM,
        reset: 'YEARLY',
        pad: 6,
        description: 'Receipt Voucher',
    },
    INV: {
        prefix: 'INV',
        format: VoucherFormat.YearlyResetYYMM,
        reset: 'YEARLY',
        pad: 6,
        description: 'Tax Invoice',
    },
    PC: {
        prefix: 'PC',
        format: VoucherFormat.YearlyResetYYMM,
        reset: 'YEARLY',
        pad: 6,
        description: 'Petty Cash',
    },
    AV: {
        prefix: 'AV',
        format: VoucherFormat.YearlyResetYYMM,
        reset: 'YEARLY',
        pad: 6,
        description: 'Advance Voucher',
    },
    WHT: {
        prefix: 'WHT',
        format: VoucherFormat.YearlyResetYYMM,
        reset: 'YEARLY',
        pad: 6,
        description: 'Withholding Tax Cert',
    },
    CIP: {
        prefix: 'CIP',
        format: VoucherFormat.YearlyRunning,
        reset: 'YEARLY',
        pad: 6,
        description: 'Construction In Progress',
    },
    FA: {
        prefix: 'FA',
        format: VoucherFormat.YearlyRunning,
        reset: 'YEARLY',
        pad: 6,
        description: 'Fixed Asset',
    },
    LSE: {
        prefix: 'LSE',
        format: VoucherFormat.YearlyRunning,
        reset: 'YEARLY',
        pad: 6,
        description: 'Lease Contract',
    },
    PPE: {
        prefix: 'PPE',
        format: VoucherFormat.YearlyRunning,
        reset: 'YEARLY',
        pad: 6,
        description: 'PPE Movement',
    },
    PT: {
        prefix: 'PT',
        format: VoucherFormat.YearlyRunning,
        reset: 'YEARLY',
        pad: 6,
        description: 'Property Tax (ภาษีที่ดิน & ป้าย)',
    },
    C: {
        prefix: 'C',
        format: VoucherFormat.Lifetime,
        reset: 'NEVER',
        pad: 5,
        description: 'Customer ID',
    },
    V: {
        prefix: 'V',
        format: VoucherFormat.Lifetime,
        reset: 'NEVER',
        pad: 5,
        description: 'Vendor ID',
    },
    EMP: {
        prefix: 'EMP',
        format: VoucherFormat.Lifetime,
        reset: 'NEVER',
        pad: 4,
        description: 'Employee ID',
    },
    BR: {
        prefix: 'BR',
        format: VoucherFormat.Lifetime,
        reset: 'NEVER',
        pad: 3,
        description: 'Branch ID',
    },
};
//# sourceMappingURL=voucher-prefixes.js.map